"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingFeeModule__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "contract IController",
                name: "_controller",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_managerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_protocolFee",
                type: "uint256",
            },
        ],
        name: "FeeActualized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newStreamingFee",
                type: "uint256",
            },
        ],
        name: "StreamingFeeUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "accrueFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "controller",
        outputs: [
            {
                internalType: "contract IController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "",
                type: "address",
            },
        ],
        name: "feeStates",
        outputs: [
            {
                internalType: "address",
                name: "feeRecipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maxStreamingFeePercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "streamingFeePercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastStreamingFeeTimestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "getFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "feeRecipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "maxStreamingFeePercentage",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "streamingFeePercentage",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lastStreamingFeeTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct StreamingFeeModule.FeeState",
                name: "_settings",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "updateFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_newFee",
                type: "uint256",
            },
        ],
        name: "updateStreamingFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var StreamingFeeModule__factory = /** @class */ (function (_super) {
    __extends(StreamingFeeModule__factory, _super);
    function StreamingFeeModule__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    StreamingFeeModule__factory.prototype.deploy = function (_controller, overrides) {
        return _super.prototype.deploy.call(this, _controller, overrides || {});
    };
    StreamingFeeModule__factory.prototype.getDeployTransaction = function (_controller, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _controller, overrides || {});
    };
    StreamingFeeModule__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StreamingFeeModule__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StreamingFeeModule__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    StreamingFeeModule__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    StreamingFeeModule__factory.bytecode = _bytecode;
    StreamingFeeModule__factory.abi = _abi;
    return StreamingFeeModule__factory;
}(ethers_1.ContractFactory));
exports.StreamingFeeModule__factory = StreamingFeeModule__factory;
//# sourceMappingURL=StreamingFeeModule__factory.js.map